/**
 * DDukDoc 예약 신청 창구(apps/booking `/api/v1/chat/chat-dashboard/reservations`) 공용 클라이언트.
 *
 * 대화 사이드바의 예약 패널(DdukdocReservationPanel)과 사이드패널 토글(SidepanelSwitch)이
 * 같은 endpoint·인증 헤더를 쓴다 — 토글은 "이 대화에 승인 대기 신청이 있는가"만 묻는다.
 */
import Auth from 'dashboard/api/auth';

export function isDdukdocReservationsEnabled() {
  return Boolean(window.ddukdocDraftApiBase && window.ddukdocConnectorId);
}

export function ddukdocAuthHeaders() {
  const auth = Auth.getAuthData();
  if (!auth || !auth['access-token']) return null;
  return {
    'x-cw-access-token': auth['access-token'],
    'x-cw-client': auth.client || '',
    'x-cw-uid': auth.uid || '',
  };
}

export function ddukdocReservationsEndpoint(query = {}) {
  const base = window.ddukdocDraftApiBase || '';
  const connectorId = window.ddukdocConnectorId || '';
  const params = new URLSearchParams({ connectorId, ...query });
  return `${base}/api/v1/chat/chat-dashboard/reservations?${params.toString()}`;
}

/**
 * 이 대화의 승인 대기 예약 신청 수. 창구가 없거나 실패하면 0 — 토글 배지는 있으면
 * 보이고 없으면 조용해야 하며, 오류를 상담원에게 보여 줄 자리가 아니다.
 */
export async function fetchPendingReservationRequestCount(conversationId) {
  if (!isDdukdocReservationsEnabled() || !conversationId) return 0;
  const headers = ddukdocAuthHeaders();
  if (!headers) return 0;
  try {
    const res = await fetch(
      ddukdocReservationsEndpoint({ conversationId: String(conversationId) }),
      { headers }
    );
    if (!res.ok) return 0;
    const data = await res.json();
    return Array.isArray(data.requests) ? data.requests.length : 0;
  } catch (error) {
    return 0;
  }
}
